import { render, staticRenderFns } from "./personalCard.vue?vue&type=template&id=1e2f43a0&"
import script from "./personalCard.vue?vue&type=script&lang=js&"
export * from "./personalCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e2f43a0')) {
      api.createRecord('1e2f43a0', component.options)
    } else {
      api.reload('1e2f43a0', component.options)
    }
    module.hot.accept("./personalCard.vue?vue&type=template&id=1e2f43a0&", function () {
      api.rerender('1e2f43a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/personalCard.vue"
export default component.exports